/**
 * Copy text to clipboard with fallbacks for HTTP, older browsers,
 * MUI dialogs, and environments where navigator.clipboard is blocked.
 */
export const copyToClipboardSync = (text) => {
  const value = String(text ?? "");
  if (!value) return false;

  try {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.setAttribute("aria-hidden", "true");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.width = "1px";
    textarea.style.height = "1px";
    textarea.style.padding = "0";
    textarea.style.border = "none";
    textarea.style.outline = "none";
    textarea.style.boxShadow = "none";
    textarea.style.background = "transparent";
    textarea.style.opacity = "0";
    textarea.style.fontSize = "16px";
    textarea.style.pointerEvents = "none";
    document.body.appendChild(textarea);

    textarea.focus({ preventScroll: true });
    textarea.select();
    textarea.setSelectionRange(0, value.length);

    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);
    return copied;
  } catch {
    return false;
  }
};

export const copyToClipboard = async (text) => {
  const value = String(text ?? "");
  if (!value) return false;

  if (copyToClipboardSync(value)) {
    return true;
  }

  if (window.isSecureContext && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // fall through
    }
  }

  return copyToClipboardSync(value);
};